/**
 * OrbDocReferenceOperatorsValidateSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceOperatorsValidateSLDocScreen
 */

import { useOrbDocReferenceOperatorsValidateSLDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceOperatorsValidateSLDocScreenLogic';
import type { OrbDocReferenceOperatorsValidateSLDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceOperatorsValidateSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceOperatorsValidateSLDocView as OrbDocReferenceOperatorsValidateSLDocViewEntity } from '@app/shared';
import { OrbDocReferenceOperatorsValidateSLDocBodyView } from '@/components/traits/OrbDocReferenceOperatorsValidateSLDocBodyView';
import { OrbDocReferenceOperatorsValidateSLDocFooterView } from '@/components/traits/OrbDocReferenceOperatorsValidateSLDocFooterView';
import { OrbDocReferenceOperatorsValidateSLDocHeaderView } from '@/components/traits/OrbDocReferenceOperatorsValidateSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceOperatorsValidateSLDocScreenViewProps {
  config?: Partial<OrbDocReferenceOperatorsValidateSLDocScreenConfig>;
}

export function OrbDocReferenceOperatorsValidateSLDocScreenView({ config: propsConfig }: OrbDocReferenceOperatorsValidateSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceOperatorsValidateSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceOperatorsValidateSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceOperatorsValidateSL" trait="OrbDocReferenceOperatorsValidateSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceOperatorsValidateSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceOperatorsValidateSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsValidateSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsValidateSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceOperatorsValidateSLDocScreenView;
